import React from "react";
import QrScanner from "qr-scanner";

class WebQrScanner extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            supportPTZ: false,
            videoTrack: null,
            zoomValue: 1.0,
            capabilities: {
                zoom: {
                    min: 1,
                    max: 1,
                    step: 1
                }
            }
        };
    }

    componentWillUnmount() {
        // Stop scanner if enabled
        if (this.qrInstanceScanner) {
            this.qrInstanceScanner.stop();
        }
    }

    async componentDidMount() {
        // Prepare ref and data
        this.qrStreamCamera    = React.createRef();
        this.qrInstanceScanner = null;

        // Prepare functions
        this.onResult     = (this.props.onResult) ? this.props.onResult : console.log;
        this.onError      = (this.props.onError)  ? this.props.onError  : console.error;
        this.handleChange = this.handleChange.bind(this);

        try {
            // Check standard API
            if (!(
                navigator?.mediaDevices?.getUserMedia &&
                navigator?.permissions?.query
            )) {
                // Propagate error
                this.onError("Standard WebMediaAPI not supported!");
            }
            else {
                // Get stream from device based to query param
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        facingMode: { ideal: "environment" },
                        zoom: true,
                        pan: true,
                        tilt: true
                    }
                });

                // Get PTZ capabilities permission
                const panTiltZoomPermissionStatus = await navigator.permissions.query({
                    name: "camera",
                    panTiltZoom: true
                });

                // Get video track capabilities and settings.
                const [videoTrack] = stream.getVideoTracks();
                const capabilities = videoTrack.getCapabilities();
                const settings     = videoTrack.getSettings();
                let zoom           = false;

                // User has granted access to the website to control camera PTZ.
                if ("zoom" in capabilities &&
                    panTiltZoomPermissionStatus.state === "granted") {
                    zoom = true;
                }

                // Enable features
                this.setState({
                    supportPTZ:   zoom,
                    videoTrack:   videoTrack,
                    capabilities: capabilities,
                    zoomValue:    settings.zoom
                },
                async () => {
                    // Check zoom enabled
                    if (zoom) {
                        // Set initial values of zoom and focus
                        await this.state.videoTrack.applyConstraints({
                            advanced: [{
                                zoom:      settings.zoom,
                                focusMode: "continuous"
                            }]
                        });
                    }

                    // Enable stream to video object
                    this.qrStreamCamera.current.srcObject = stream;

                    // Create qr-scanner instance
                    this.qrInstanceScanner = new QrScanner(
                        this.qrStreamCamera.current,
                        (result) => {
                            // Check for not empty string
                            if (typeof result.data === "string" &&
                                result.data.length > 0) {
                                // Propagate result
                                this.onResult(result.data);
                            }
                        },
                        {
                            onDecodeError: (error) => this.onError(error.message),
                            highlightScanRegion: true,
                            highlightCodeOutline: true
                        }
                    );

                    // Start qr-scanner
                    this.qrInstanceScanner.start();
                });
            }
        }
        catch (error) {
            // Propagate error
            this.onError(error.message);
        }
    }

    handleChange(event) {
        // Set value for zoom
        this.setState({
            zoomValue: event.target.value
        },
        async () => {
            // Get new state
            const { zoomValue } = this.state;

            // Change values of zoom and focus
            await this.state.videoTrack.applyConstraints({
                advanced: [{
                    zoom:      zoomValue,
                    focusMode: "continuous"
                }]
            });
        });
    }

    render() {
        const {
            zoomValue,
            supportPTZ,
            capabilities
        } = this.state;

        return (
            <div className="web-qrscanner-container">
                <video
                    ref={this.qrStreamCamera}
                    playsInline={true}
                    autoPlay={true}
                />
                {supportPTZ && <div className="zoom-ctrl">
                    <input
                        type="range"
                        value={zoomValue}
                        onChange={this.handleChange}
                        min={capabilities.zoom.min}
                        max={capabilities.zoom.max}
                        step={capabilities.zoom.step}
                    />
                </div>}
            </div>
        );
    }
}

export default WebQrScanner;
